<template>
  <footer class="footer-four">
    <div
      class="footer-container"
      :style="{
        color: configDataForm.fontColor,
        'background-color': configDataForm.backGroundColor,
        'background-repeat': 'no-repeat',
        'background-size': 'contain',
        'background-position': 'center',
        '--footer-font-color': configDataForm.fontColor,
      }"
    >
      <div
        class="footer-container-inner"
        @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
        @mouseleave="handleShowOperationBtn(false)"
      >
        <address class="connect">
          <article v-for="item in configDataForm.items" :key="item" class="connect-item">
            <figure 
              class="connect-icon"
              :style="{
                'background-color': configDataForm.fontColor,
                '-webkit-mask-image': `url(${item.iconFullUrl || noUpload})`,
                'mask-image': `url(${item.iconFullUrl || noUpload})`,
                '-webkit-mask-size': 'contain',
                'mask-size': 'contain',
                '-webkit-mask-repeat': 'no-repeat',
                'mask-repeat': 'no-repeat',
                '-webkit-mask-position': 'center',
                'mask-position': 'center',
              }"
            ></figure>
            <span class="connect-desc">
              {{ item.text }}
            </span>
          </article>
        </address>
        <figure class="logo">
          <img 
            :src="configDataForm.logoImageFullUrl || noUpload" 
            alt="Logo"
            loading="lazy"
          />
        </figure>
        <div class="qr-code">
          <figure
            v-for="item in configDataForm.qrCodeItems"
            :key="item"
            class="qr-code-item"
          >
            <figcaption class="qr-code-item-image">
              <img 
                :src="item.iconFullUrl || noUpload" 
                :alt="item.text || '二维码'"
                loading="lazy"
              />
            </figcaption>
            <span class="qr-code-item-desc">{{ item.text }}</span>
          </figure>
        </div>
        <operation-container
          v-if="showOperationBtn && !showEditForm"
          :component-data="props.componentData"
          :show-edit-content-button="props.showEditContentButton"
          :show-edit-components-button="props.showEditComponentsButton"
          :show-delete-components-button="props.showDeleteComponentsButton"
          :show-insert-components-button="props.showInsertComponentsButton"
          :show-sort-components-button="props.showSortComponentsButton"
          @handle-show-edit-form="handleShowEditForm"
          @handle-change-components="handleChangeComponents"
          @handle-delete-components="handleDeleteComponents"
          @handle-insert-components="handleInsertComponents"
          @handle-sort-components="handleSortComponents"
        ></operation-container>
      </div>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <footer-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></footer-edit-form>
    </el-drawer>
  </footer>
</template>
<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import FooterEditForm from './FooterEditFormFour.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

// console.log('props:',props);

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
 query: '?url',
});
// 直接获取目标图片 URL
const noUpload = images['/src/assets/images/web/common/other/no-upload.png']?.default;

const configDataForm = ref({
  items: [
    {
      sortNum: 1,
      iconType: 1,
      iconName: '自定义上传图标1.jpg',
      iconFileKey: 'icon1',
      text: '地址：xxxxxx',
    },
    {
      sortNum: 2,
      iconType: 1,
      iconName: '系统图标1.jpg',
      iconFileKey: 'icon2',
      text: '电话：028-xxxxxx',
    },
  ],
  qrCodeItems: [
    {
      sortNum: 1,
      iconType: 1,
      iconName: '自定义上传图标1.jpg',
      iconFileKey: 'qrCode1',
      text: '地址：xxxxxx',
    },
    {
      sortNum: 2,
      iconType: 1,
      iconName: '系统图标1.jpg',
      iconFileKey: 'qrCode2',
      text: '电话：028-xxxxxx',
    },
  ],
  logoImageObj: null,
  logoImageName: '示例图片.jpg',
  logoImageFileKey: 'logoImage',
  backGroundImageObj: null,
  backgroundImageName: '示例图片.jpg',
  backgroundImageFileKey: 'backGroundImage',
  fontColor: '#ffffff',
  backGroundColor: '#2A3347',
});

if (props.componentData.configData) {
  // 服务器渲染的直接调用
  configDataForm.value = JSON.parse(props.componentData.configData);
  configDataForm.value.items.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });
  configDataForm.value.qrCodeItems.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });

  // 后台编辑的处理一下
  // nextTick(() => {
  //   configDataForm.value = JSON.parse(props.componentData.configData);
  //   configDataForm.value.items.sort((a, b) => {
  //     return a.sortNum - b.sortNum;
  //   });
  //   configDataForm.value.qrCodeItems.sort((a, b) => {
  //     return a.sortNum - b.sortNum;
  //   });
  // });
}

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // console.log('configDataForm--1-FooterThree:', configDataForm);
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

// ============================================
// FooterFour 组件变量（继承官网设计系统）
// ============================================
$footer-radius-md: $website-radius-md;           // 8px
$footer-duration-normal: $website-duration-normal; // 250ms
$footer-ease-out: $website-ease-out;
$footer-shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
$footer-shadow-hover: 0 8px 20px rgba(0, 0, 0, 0.15);

// 重置语义化标签默认样式
figure {
  margin: 0;
  padding: 0;
}

figcaption {
  margin: 0;
  padding: 0;
  display: block;
}

address {
  font-style: normal;
}

/* PC端样式 */
@include pc {
  .footer-container {
    position: relative;
    // [侧边距调整-2026-03-09] 100px → 80px
    padding: 20px 80px 0;
    
    .footer-container-inner {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      padding-bottom: 20px;
      // [协调-2026-03-10] 分隔线颜色统一
      border-bottom: 1px solid #cfd0c5;

      .connect {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .connect-item {
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .connect-icon {
          display: block;
          width: 20px;
          height: 20px;
          margin-right: 20px;
          border-radius: $footer-radius-md;
          transition: transform $footer-duration-normal $footer-ease-out;
          
          &:hover {
            transform: scale(1.1) rotate(5deg);
          }
        }

        .connect-desc {
          display: flex;
          align-items: center;
          height: 40px;
          font-size: 18px;
        }
      }

      .logo {
        grid-row: 1;
        width: 547px;
        height: 167px;
        border-radius: $footer-radius-md;
        overflow: hidden;
        transition: transform $footer-duration-normal $footer-ease-out;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        &:hover {
          transform: scale(1.02);
        }
      }

      .qr-code {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        
        .qr-code-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;
          width: 200px;
          height: 180px;
          // [hover效果-2026-03-09] 添加过渡动画
          border-radius: $footer-radius-md;
          transition: transform $footer-duration-normal $footer-ease-out, 
                      box-shadow $footer-duration-normal $footer-ease-out;

          .qr-code-item-image {
            width: 147px;
            height: 147px;
            border-radius: $footer-radius-md;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }
          
          .qr-code-item-desc {
            font-size: 16px;
            text-align: center;
          }
          
          &:hover {
            transform: translateY(-4px);
            box-shadow: $footer-shadow-hover;
          }
        }

        .qr-code-item:last-of-type {
          margin-right: -28px;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

// ============================================
// FooterFour 组件变量（移动端）
// ============================================
$footer-radius-md: $website-radius-md;
$footer-duration-normal: $website-duration-normal;
$footer-ease-out: $website-ease-out;

// 重置语义化标签默认样式
figure {
  margin: 0;
  padding: 0;
}

figcaption {
  margin: 0;
  padding: 0;
  display: block;
}

address {
  font-style: normal;
}

/* [移动端优化-2026-03-10] */
@media screen and (max-width: 1180px) {
  .footer-container {
    position: relative;
    width: 100%;
    height: auto;
    padding: 2vw 4vw 4vw;
    
    .footer-container-inner {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding-bottom: 4vw;

      .connect {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .connect-item {
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        // [灵动-2026-03-10] 图标呼吸脉动
        .connect-icon {
          display: block;
          width: 4vw;
          height: 4vw;
          margin-right: 4vw;
          border-radius: 1.2vw;
          transition: transform $footer-duration-normal $footer-ease-out;
          animation: breathe 2.5s ease-in-out infinite;
          
          &:active {
            transform: scale(0.9);
            animation: none;
          }
        }

        .connect-desc {
          display: flex;
          align-items: center;
          height: 8.3vw;
          font-size: 3.75vw;
        }
      }

      // [灵动-2026-03-10] Logo 悬浮微动
      .logo {
        grid-row: 1;
        width: 92vw;
        height: 46vw;
        margin: 4vw 0;
        border-radius: 3vw;
        overflow: hidden;
        transition: transform $footer-duration-normal $footer-ease-out;
        animation: float 3s ease-in-out infinite;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        &:active {
          transform: scale(0.98);
          animation: none;
        }
      }

      .qr-code {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 92vw;
        
        .qr-code-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;
          height: 46vw;
          border-radius: 2vw;
          transition: transform $footer-duration-normal $footer-ease-out;

          // [灵动-2026-03-10] 二维码图片光泽效果
          .qr-code-item-image {
            position: relative;
            width: 24vw;
            height: 24vw;
            border-radius: 3vw;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
            
            // 光泽滑动效果
            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: -100%;
              width: 50%;
              height: 100%;
              background: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.3),
                transparent
              );
              animation: shine 3s ease-in-out infinite;
              pointer-events: none;
            }
          }
          
          .qr-code-item-desc {
            font-size: 3.3vw;
            text-align: center;
          }
          
          // [灵动-2026-03-10] 触摸缩放
          &:active {
            transform: scale(0.95);
            
            .qr-code-item-image::after {
              animation: none;
            }
          }
        }
      }
    }
  }
}
</style>
